module.exports = __webpack_public_path__ + "img/logo-smap.364d5e11.png";